export enum ProcessTime {
    dt = 'dt',
    rt = 'rt'
}
